import { PayRatePayFunctionType } from '@scale/shared/defaults';
import {
  GetProjectOnboardingFlowOutlineResponse,
  PublicCourseDetailsDTO,
} from '@scale/shared/outlier/api';

type TrainingNode = GetProjectOnboardingFlowOutlineResponse['trainingNodes'][0];
type AssessmentNode = GetProjectOnboardingFlowOutlineResponse['assessmentNodes'][0];
type TaskingNode = GetProjectOnboardingFlowOutlineResponse['taskingNodes'][0];
export type ProjectOutlineNode = TrainingNode | AssessmentNode | TaskingNode;

export type ProjectOutlineStoreState = {
  projectName: string;
  currentNodeIndex: number;
  completedNodeIndex: number;
  trainingNodes: TrainingNode[];
  assessmentNodes: AssessmentNode[];
  taskingNodes: TaskingNode[];
  courseMap: Record<string, PublicCourseDetailsDTO>;
  isVisible: boolean;
  taskingPayRate?: number | null;
  assessmentPayRate?: number;
  payRateType?: PayRatePayFunctionType;
  setProjectName: (name: string) => void;
  setCourseMap: (courseMap: Record<string, PublicCourseDetailsDTO>) => void;
  setCurrentNodeIndex: (index: number) => void;
  setCompletedNodeIndex: (index: number) => void;
  setNodes: (nodes: {
    trainingNodes: TrainingNode[];
    assessmentNodes: AssessmentNode[];
    taskingNodes: TaskingNode[];
  }) => void;
  showProjectOutline: () => void;
  hideProjectOutline: () => void;
  toggleProjectOutline: () => void;
  setPayRates: (payRates: {
    taskingPayRate?: number | null;
    assessmentPayRate?: number;
    payRateType?: PayRatePayFunctionType;
  }) => void;
};

export enum ProjectOutlineNodeStatus {
  IN_PROGRESS = 'In progress',
  COMPLETED = 'Completed',
  NOT_STARTED = 'Not started',
}

export enum ProjectOutlineOnboardingStates {
  Training = 'Training',
  Assessment = 'Assessment',
  Tasking = 'Tasking',
}
